import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { NGXLogger } from "ngx-logger";
import { Observable } from "rxjs";
import { Workspace } from "./state/workspaces.model";
import { selectActiveWorkspace } from "./state/workspaces.selectors";

@Injectable({ providedIn: "root" })
export class WorkspaceInterceptor implements HttpInterceptor {
  workspace: Workspace;
  private readonly skipWorkspaceParamsUrls = [
    "/api-usage/model-stats",
    "/api-usage/model-stats/timeseries",
    "/api-usage/category-stats",
  ];

  constructor(
    private store: Store<any>,
    private logger: NGXLogger,
  ) {
    this.store
      .select(selectActiveWorkspace)
      .subscribe((w) => (this.workspace = w));
  }

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (this.workspace && !this.shouldSkipWorkspaceParams(req.url)) {
      const params = {};
      params["tenant"] = this.workspace.uuid;
      params["workspace"] = this.workspace.uuid;
      const clonedRequest = req.clone({ setParams: params });
      return next.handle(clonedRequest);
    }

    // If there is no activated workspace, don't alter the request
    return next.handle(req);
  }

  private shouldSkipWorkspaceParams(url: string): boolean {
    if (/\/tenants\/[^/]+\/logo(?:\?|$)/.test(url)) return true;
    return this.skipWorkspaceParamsUrls.some((path) => url.includes(path));
  }
}
